module.exports = __webpack_public_path__ + "static/media/5671.54df95cd.jpg";